import classNames from 'classnames';
import s from '#components/common/textLink/textLink.module.scss';
import Link from 'next/link';

type Props = {
  text: string;
  classes?: string;
  linkDestination?: string;
  size?: 'tiny' | 'medium';
};

const TextLink = ({
  text,
  classes = '',
  linkDestination,
  size = 'medium',
}: Props) => {
  const blockClass = classNames(s.host, classes, s[size]);

  return (
    <Link href={linkDestination} passHref={true} legacyBehavior>
      <a className={blockClass}>{text}</a>
    </Link>
  );
};

export default TextLink;
